/* import __COLOCATED_TEMPLATE__ from './trash-can.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();